/* eslint-disable */
export type ChallengeMode = 'TRADITIONAL'|'CASTLE_DEFENSE';

export const ChallengeModes: { [name: string]: ChallengeMode } = {
  TRADITIONAL: 'TRADITIONAL',
  CASTLE_DEFENSE: 'CASTLE_DEFENSE',
};